var map = {
	".": 9543,
	"./": 9543,
	"./assets/css/index.css": 5481,
	"./declarations.d": 9619,
	"./declarations.d.ts": 9619,
	"./hooks/useComponentStyle": 8770,
	"./hooks/useComponentStyle.tsx": 8770,
	"./i18n": 743,
	"./i18n/": 743,
	"./i18n/en_UK": 610,
	"./i18n/en_UK.json": 610,
	"./i18n/index": 743,
	"./i18n/index.ts": 743,
	"./index": 9543,
	"./index.tsx": 9543,
	"./react-app-env.d": 5059,
	"./react-app-env.d.ts": 5059,
	"./services": 9579,
	"./services/": 9579,
	"./services/BaseService": 8687,
	"./services/BaseService.ts": 8687,
	"./services/index": 9579,
	"./services/index.ts": 9579,
	"./services/janus/lanuarius/LanuariusBaseService": 5428,
	"./services/janus/lanuarius/LanuariusBaseService.ts": 5428,
	"./services/omnehost/OmneHostService": 3861,
	"./services/omnehost/OmneHostService.ts": 3861,
	"./shared/LanguageDropdown": 2117,
	"./shared/LanguageDropdown.tsx": 2117,
	"./templates/host/launchpad/assets/style.module.css": 4641,
	"./templates/host/launchpad/components/About": 8122,
	"./templates/host/launchpad/components/About.tsx": 8122,
	"./templates/host/launchpad/components/Blog": 8941,
	"./templates/host/launchpad/components/Blog.tsx": 8941,
	"./templates/host/launchpad/components/Events": 6790,
	"./templates/host/launchpad/components/Events.tsx": 6790,
	"./templates/host/launchpad/components/Home": 4216,
	"./templates/host/launchpad/components/Home.tsx": 4216,
	"./templates/host/launchpad/components/Landing": 6384,
	"./templates/host/launchpad/components/Landing.tsx": 6384,
	"./templates/host/launchpad/components/Tournaments": 7973,
	"./templates/host/launchpad/components/Tournaments.tsx": 7973,
	"./templates/host/launchpad/definition": 5461,
	"./templates/host/launchpad/definition.ts": 5461,
	"./templates/host/waterway/assets/style.module.css": 6055,
	"./templates/host/waterway/components/About": 4620,
	"./templates/host/waterway/components/About.tsx": 4620,
	"./templates/host/waterway/components/Blog": 9855,
	"./templates/host/waterway/components/Blog.tsx": 9855,
	"./templates/host/waterway/components/Events": 7360,
	"./templates/host/waterway/components/Events.tsx": 7360,
	"./templates/host/waterway/components/Home": 4770,
	"./templates/host/waterway/components/Home.tsx": 4770,
	"./templates/host/waterway/components/Landing": 1438,
	"./templates/host/waterway/components/Landing.tsx": 1438,
	"./templates/host/waterway/components/Store": 5456,
	"./templates/host/waterway/components/Store.tsx": 5456,
	"./templates/host/waterway/components/Tournaments": 9003,
	"./templates/host/waterway/components/Tournaments.tsx": 9003,
	"./templates/host/waterway/components/common/AccordionItem": 7066,
	"./templates/host/waterway/components/common/AccordionItem.tsx": 7066,
	"./templates/host/waterway/components/common/BlogCard": 4739,
	"./templates/host/waterway/components/common/BlogCard.tsx": 4739,
	"./templates/host/waterway/components/common/Btn": 8837,
	"./templates/host/waterway/components/common/Btn.tsx": 8837,
	"./templates/host/waterway/components/common/EventItem": 5892,
	"./templates/host/waterway/components/common/EventItem.tsx": 5892,
	"./templates/host/waterway/components/common/FilterTags": 6028,
	"./templates/host/waterway/components/common/FilterTags.tsx": 6028,
	"./templates/host/waterway/components/common/ManagerCard": 9310,
	"./templates/host/waterway/components/common/ManagerCard.tsx": 9310,
	"./templates/host/waterway/components/common/ManagerModal": 8001,
	"./templates/host/waterway/components/common/ManagerModal.tsx": 8001,
	"./templates/host/waterway/components/common/PageHead": 6770,
	"./templates/host/waterway/components/common/PageHead.tsx": 6770,
	"./templates/host/waterway/components/common/Pagination": 5593,
	"./templates/host/waterway/components/common/Pagination.tsx": 5593,
	"./templates/host/waterway/components/common/ProductCard": 150,
	"./templates/host/waterway/components/common/ProductCard.tsx": 150,
	"./templates/host/waterway/components/common/SectionHead": 9262,
	"./templates/host/waterway/components/common/SectionHead.tsx": 9262,
	"./templates/host/waterway/components/common/StatCard": 3445,
	"./templates/host/waterway/components/common/StatCard.tsx": 3445,
	"./templates/host/waterway/components/common/TournamentCard": 2178,
	"./templates/host/waterway/components/common/TournamentCard.tsx": 2178,
	"./templates/host/waterway/components/common/TournamentDetail": 732,
	"./templates/host/waterway/components/common/TournamentDetail.tsx": 732,
	"./templates/host/waterway/components/home/AboutStats": 7367,
	"./templates/host/waterway/components/home/AboutStats.tsx": 7367,
	"./templates/host/waterway/components/home/Crew": 9496,
	"./templates/host/waterway/components/home/Crew.tsx": 9496,
	"./templates/host/waterway/components/home/EventsAccordion": 1500,
	"./templates/host/waterway/components/home/EventsAccordion.tsx": 1500,
	"./templates/host/waterway/components/home/FeaturedTournaments": 8693,
	"./templates/host/waterway/components/home/FeaturedTournaments.tsx": 8693,
	"./templates/host/waterway/components/home/Hero": 1203,
	"./templates/host/waterway/components/home/Hero.tsx": 1203,
	"./templates/host/waterway/components/home/LatestBlog": 9782,
	"./templates/host/waterway/components/home/LatestBlog.tsx": 9782,
	"./templates/host/waterway/components/home/LogoStrip": 8402,
	"./templates/host/waterway/components/home/LogoStrip.tsx": 8402,
	"./templates/host/waterway/components/home/Testimonials": 6567,
	"./templates/host/waterway/components/home/Testimonials.tsx": 6567,
	"./templates/host/waterway/components/layout/Footer": 6667,
	"./templates/host/waterway/components/layout/Footer.tsx": 6667,
	"./templates/host/waterway/components/layout/Navbar": 5296,
	"./templates/host/waterway/components/layout/Navbar.tsx": 5296,
	"./templates/host/waterway/data": 8186,
	"./templates/host/waterway/data.ts": 8186,
	"./templates/host/waterway/definition": 8351,
	"./templates/host/waterway/definition.ts": 8351,
	"./templates/host/waterway/helpers": 4885,
	"./templates/host/waterway/helpers.ts": 4885,
	"./templates/host/waterway/hooks": 8828,
	"./templates/host/waterway/hooks.ts": 8828,
	"./templates/host/waterway/i18n": 2467,
	"./templates/host/waterway/i18n/": 2467,
	"./templates/host/waterway/i18n/en_UK": 6024,
	"./templates/host/waterway/i18n/en_UK.json": 6024,
	"./templates/host/waterway/i18n/index": 2467,
	"./templates/host/waterway/i18n/index.tsx": 2467,
	"./templates/member/launchpad/assets/style.module.css": 7981,
	"./templates/member/launchpad/components/Achievement": 8512,
	"./templates/member/launchpad/components/Achievement.tsx": 8512,
	"./templates/member/launchpad/components/Gallery": 9495,
	"./templates/member/launchpad/components/Gallery.tsx": 9495,
	"./templates/member/launchpad/components/Home": 9532,
	"./templates/member/launchpad/components/Home.tsx": 9532,
	"./templates/member/launchpad/components/Landing": 28,
	"./templates/member/launchpad/components/Landing.tsx": 28,
	"./templates/member/launchpad/components/Merch": 5628,
	"./templates/member/launchpad/components/Merch.tsx": 5628,
	"./templates/member/launchpad/components/Schedule": 1466,
	"./templates/member/launchpad/components/Schedule.tsx": 1466,
	"./templates/member/launchpad/components/TeamHistory": 2636,
	"./templates/member/launchpad/components/TeamHistory.tsx": 2636,
	"./templates/member/launchpad/definition": 5577,
	"./templates/member/launchpad/definition.ts": 5577,
	"./templates/member/panteran/assets/style.module.css": 7834,
	"./templates/member/panteran/components/Achievement": 9973,
	"./templates/member/panteran/components/Achievement.tsx": 9973,
	"./templates/member/panteran/components/Gallery": 9634,
	"./templates/member/panteran/components/Gallery.tsx": 9634,
	"./templates/member/panteran/components/Home": 6995,
	"./templates/member/panteran/components/Home.tsx": 6995,
	"./templates/member/panteran/components/Landing": 6369,
	"./templates/member/panteran/components/Landing.tsx": 6369,
	"./templates/member/panteran/components/Schedule": 2233,
	"./templates/member/panteran/components/Schedule.tsx": 2233,
	"./templates/member/panteran/components/Store": 6087,
	"./templates/member/panteran/components/Store.tsx": 6087,
	"./templates/member/panteran/components/TeamHistory": 6137,
	"./templates/member/panteran/components/TeamHistory.tsx": 6137,
	"./templates/member/panteran/components/common/AchievementCard": 2091,
	"./templates/member/panteran/components/common/AchievementCard.tsx": 2091,
	"./templates/member/panteran/components/common/Btn": 8220,
	"./templates/member/panteran/components/common/Btn.tsx": 8220,
	"./templates/member/panteran/components/common/GalleryItem": 2487,
	"./templates/member/panteran/components/common/GalleryItem.tsx": 2487,
	"./templates/member/panteran/components/common/HeroStat": 1568,
	"./templates/member/panteran/components/common/HeroStat.tsx": 1568,
	"./templates/member/panteran/components/common/MatchRow": 9759,
	"./templates/member/panteran/components/common/MatchRow.tsx": 9759,
	"./templates/member/panteran/components/common/Pagination": 8734,
	"./templates/member/panteran/components/common/Pagination.tsx": 8734,
	"./templates/member/panteran/components/common/SectionHeader": 22,
	"./templates/member/panteran/components/common/SectionHeader.tsx": 22,
	"./templates/member/panteran/components/common/TagBadge": 1123,
	"./templates/member/panteran/components/common/TagBadge.tsx": 1123,
	"./templates/member/panteran/components/common/TeamCard": 8831,
	"./templates/member/panteran/components/common/TeamCard.tsx": 8831,
	"./templates/member/panteran/components/home/AwardsBand": 8859,
	"./templates/member/panteran/components/home/AwardsBand.tsx": 8859,
	"./templates/member/panteran/components/home/Bio": 192,
	"./templates/member/panteran/components/home/Bio.tsx": 192,
	"./templates/member/panteran/components/home/GalleryPreview": 9978,
	"./templates/member/panteran/components/home/GalleryPreview.tsx": 9978,
	"./templates/member/panteran/components/home/Hero": 6280,
	"./templates/member/panteran/components/home/Hero.tsx": 6280,
	"./templates/member/panteran/components/home/Quote": 9106,
	"./templates/member/panteran/components/home/Quote.tsx": 9106,
	"./templates/member/panteran/components/home/RecentAchievements": 9081,
	"./templates/member/panteran/components/home/RecentAchievements.tsx": 9081,
	"./templates/member/panteran/components/home/SocialBand": 3048,
	"./templates/member/panteran/components/home/SocialBand.tsx": 3048,
	"./templates/member/panteran/components/home/Sponsors": 6925,
	"./templates/member/panteran/components/home/Sponsors.tsx": 6925,
	"./templates/member/panteran/components/home/TeamsCarousel": 6062,
	"./templates/member/panteran/components/home/TeamsCarousel.tsx": 6062,
	"./templates/member/panteran/components/home/UpcomingMatches": 347,
	"./templates/member/panteran/components/home/UpcomingMatches.tsx": 347,
	"./templates/member/panteran/components/layout/Footer": 5140,
	"./templates/member/panteran/components/layout/Footer.tsx": 5140,
	"./templates/member/panteran/components/layout/Navbar": 2175,
	"./templates/member/panteran/components/layout/Navbar.tsx": 2175,
	"./templates/member/panteran/data": 2619,
	"./templates/member/panteran/data.ts": 2619,
	"./templates/member/panteran/definition": 3674,
	"./templates/member/panteran/definition.ts": 3674,
	"./templates/member/panteran/helpers": 5878,
	"./templates/member/panteran/helpers.ts": 5878,
	"./templates/member/panteran/hooks": 4563,
	"./templates/member/panteran/hooks.ts": 4563,
	"./templates/member/panteran/i18n": 5268,
	"./templates/member/panteran/i18n/": 5268,
	"./templates/member/panteran/i18n/en_UK": 4185,
	"./templates/member/panteran/i18n/en_UK.json": 4185,
	"./templates/member/panteran/i18n/index": 5268,
	"./templates/member/panteran/i18n/index.tsx": 5268,
	"./templates/member/sleeky/assets/style.module.css": 8710,
	"./templates/member/sleeky/components/Achievement": 3037,
	"./templates/member/sleeky/components/Achievement.tsx": 3037,
	"./templates/member/sleeky/components/Gallery": 7802,
	"./templates/member/sleeky/components/Gallery.tsx": 7802,
	"./templates/member/sleeky/components/Home": 8107,
	"./templates/member/sleeky/components/Home.tsx": 8107,
	"./templates/member/sleeky/components/Landing": 8553,
	"./templates/member/sleeky/components/Landing.tsx": 8553,
	"./templates/member/sleeky/components/Schedule": 5697,
	"./templates/member/sleeky/components/Schedule.tsx": 5697,
	"./templates/member/sleeky/components/Store": 8095,
	"./templates/member/sleeky/components/Store.tsx": 8095,
	"./templates/member/sleeky/components/TeamHistory": 9057,
	"./templates/member/sleeky/components/TeamHistory.tsx": 9057,
	"./templates/member/sleeky/components/common/Btn": 8628,
	"./templates/member/sleeky/components/common/Btn.tsx": 8628,
	"./templates/member/sleeky/components/common/GalleryItem": 7423,
	"./templates/member/sleeky/components/common/GalleryItem.tsx": 7423,
	"./templates/member/sleeky/components/common/MatchCard": 4477,
	"./templates/member/sleeky/components/common/MatchCard.tsx": 4477,
	"./templates/member/sleeky/components/common/MatchRow": 7047,
	"./templates/member/sleeky/components/common/MatchRow.tsx": 7047,
	"./templates/member/sleeky/components/common/PageHead": 1149,
	"./templates/member/sleeky/components/common/PageHead.tsx": 1149,
	"./templates/member/sleeky/components/common/Pagination": 1462,
	"./templates/member/sleeky/components/common/Pagination.tsx": 1462,
	"./templates/member/sleeky/components/common/SectionHeader": 5230,
	"./templates/member/sleeky/components/common/SectionHeader.tsx": 5230,
	"./templates/member/sleeky/components/common/TagBadge": 6635,
	"./templates/member/sleeky/components/common/TagBadge.tsx": 6635,
	"./templates/member/sleeky/components/common/TeamTile": 9,
	"./templates/member/sleeky/components/common/TeamTile.tsx": 9,
	"./templates/member/sleeky/components/common/TrophyCard": 1862,
	"./templates/member/sleeky/components/common/TrophyCard.tsx": 1862,
	"./templates/member/sleeky/components/home/GalleryPreview": 8642,
	"./templates/member/sleeky/components/home/GalleryPreview.tsx": 8642,
	"./templates/member/sleeky/components/home/Hero": 2256,
	"./templates/member/sleeky/components/home/Hero.tsx": 2256,
	"./templates/member/sleeky/components/home/Intro": 3288,
	"./templates/member/sleeky/components/home/Intro.tsx": 3288,
	"./templates/member/sleeky/components/home/LatestMatches": 6202,
	"./templates/member/sleeky/components/home/LatestMatches.tsx": 6202,
	"./templates/member/sleeky/components/home/Sponsors": 9765,
	"./templates/member/sleeky/components/home/Sponsors.tsx": 9765,
	"./templates/member/sleeky/components/home/StoreSplit": 2893,
	"./templates/member/sleeky/components/home/StoreSplit.tsx": 2893,
	"./templates/member/sleeky/components/home/TeamTiles": 3576,
	"./templates/member/sleeky/components/home/TeamTiles.tsx": 3576,
	"./templates/member/sleeky/components/home/Trophies": 2218,
	"./templates/member/sleeky/components/home/Trophies.tsx": 2218,
	"./templates/member/sleeky/components/layout/Footer": 4684,
	"./templates/member/sleeky/components/layout/Footer.tsx": 4684,
	"./templates/member/sleeky/components/layout/Navbar": 9239,
	"./templates/member/sleeky/components/layout/Navbar.tsx": 9239,
	"./templates/member/sleeky/data": 8339,
	"./templates/member/sleeky/data.ts": 8339,
	"./templates/member/sleeky/definition": 5026,
	"./templates/member/sleeky/definition.ts": 5026,
	"./templates/member/sleeky/helpers": 4494,
	"./templates/member/sleeky/helpers.ts": 4494,
	"./templates/member/sleeky/hooks": 2955,
	"./templates/member/sleeky/hooks.ts": 2955,
	"./templates/member/sleeky/i18n": 9628,
	"./templates/member/sleeky/i18n/": 9628,
	"./templates/member/sleeky/i18n/en_UK": 6401,
	"./templates/member/sleeky/i18n/en_UK.json": 6401,
	"./templates/member/sleeky/i18n/index": 9628,
	"./templates/member/sleeky/i18n/index.tsx": 9628,
	"./templates/program/assets/style.module.css": 1912,
	"./templates/program/components/Home": 5085,
	"./templates/program/components/Home.tsx": 5085,
	"./templates/program/components/Landing": 9039,
	"./templates/program/components/Landing.tsx": 9039,
	"./templates/program/components/Leaderboard": 7551,
	"./templates/program/components/Leaderboard.tsx": 7551,
	"./templates/program/components/Tournaments": 8726,
	"./templates/program/components/Tournaments.tsx": 8726,
	"./templates/registrar": 1469,
	"./templates/registrar.ts": 1469,
	"./templates/team/espart/assets/style.module.css": 4901,
	"./templates/team/espart/components/Achievements": 6241,
	"./templates/team/espart/components/Achievements.tsx": 6241,
	"./templates/team/espart/components/Activities": 4510,
	"./templates/team/espart/components/Activities.tsx": 4510,
	"./templates/team/espart/components/Gallery": 4291,
	"./templates/team/espart/components/Gallery.tsx": 4291,
	"./templates/team/espart/components/Home": 2168,
	"./templates/team/espart/components/Home.tsx": 2168,
	"./templates/team/espart/components/Landing": 2736,
	"./templates/team/espart/components/Landing.tsx": 2736,
	"./templates/team/espart/components/Members": 7736,
	"./templates/team/espart/components/Members.tsx": 7736,
	"./templates/team/espart/components/News": 2440,
	"./templates/team/espart/components/News.tsx": 2440,
	"./templates/team/espart/components/Schedule": 6470,
	"./templates/team/espart/components/Schedule.tsx": 6470,
	"./templates/team/espart/components/Store": 5490,
	"./templates/team/espart/components/Store.tsx": 5490,
	"./templates/team/espart/components/common/Btn": 4955,
	"./templates/team/espart/components/common/Btn.tsx": 4955,
	"./templates/team/espart/components/common/FilterChips": 888,
	"./templates/team/espart/components/common/FilterChips.tsx": 888,
	"./templates/team/espart/components/common/GalleryItem": 7036,
	"./templates/team/espart/components/common/GalleryItem.tsx": 7036,
	"./templates/team/espart/components/common/Highlight": 3587,
	"./templates/team/espart/components/common/Highlight.tsx": 3587,
	"./templates/team/espart/components/common/MatchRow": 3138,
	"./templates/team/espart/components/common/MatchRow.tsx": 3138,
	"./templates/team/espart/components/common/MemberCard": 1003,
	"./templates/team/espart/components/common/MemberCard.tsx": 1003,
	"./templates/team/espart/components/common/MemberModal": 5238,
	"./templates/team/espart/components/common/MemberModal.tsx": 5238,
	"./templates/team/espart/components/common/NewsCard": 1032,
	"./templates/team/espart/components/common/NewsCard.tsx": 1032,
	"./templates/team/espart/components/common/PageHead": 6456,
	"./templates/team/espart/components/common/PageHead.tsx": 6456,
	"./templates/team/espart/components/common/Pagination": 5243,
	"./templates/team/espart/components/common/Pagination.tsx": 5243,
	"./templates/team/espart/components/common/ProductCard": 2160,
	"./templates/team/espart/components/common/ProductCard.tsx": 2160,
	"./templates/team/espart/components/common/ScrollTrack": 2987,
	"./templates/team/espart/components/common/ScrollTrack.tsx": 2987,
	"./templates/team/espart/components/common/TournamentCard": 6852,
	"./templates/team/espart/components/common/TournamentCard.tsx": 6852,
	"./templates/team/espart/components/common/TrophyCard": 1515,
	"./templates/team/espart/components/common/TrophyCard.tsx": 1515,
	"./templates/team/espart/components/common/match": 3200,
	"./templates/team/espart/components/common/match.ts": 3200,
	"./templates/team/espart/components/home/CollectionSlider": 6554,
	"./templates/team/espart/components/home/CollectionSlider.tsx": 6554,
	"./templates/team/espart/components/home/FanArena": 2073,
	"./templates/team/espart/components/home/FanArena.tsx": 2073,
	"./templates/team/espart/components/home/HeroSlideshow": 3425,
	"./templates/team/espart/components/home/HeroSlideshow.tsx": 3425,
	"./templates/team/espart/components/home/LogoBar": 5617,
	"./templates/team/espart/components/home/LogoBar.tsx": 5617,
	"./templates/team/espart/components/home/NewsMatches": 8581,
	"./templates/team/espart/components/home/NewsMatches.tsx": 8581,
	"./templates/team/espart/components/home/PartnersSection": 7207,
	"./templates/team/espart/components/home/PartnersSection.tsx": 7207,
	"./templates/team/espart/components/home/SocialBand": 2177,
	"./templates/team/espart/components/home/SocialBand.tsx": 2177,
	"./templates/team/espart/components/home/SquadCarousel": 3725,
	"./templates/team/espart/components/home/SquadCarousel.tsx": 3725,
	"./templates/team/espart/components/layout/Footer": 8081,
	"./templates/team/espart/components/layout/Footer.tsx": 8081,
	"./templates/team/espart/components/layout/Navbar": 990,
	"./templates/team/espart/components/layout/Navbar.tsx": 990,
	"./templates/team/espart/data": 1832,
	"./templates/team/espart/data.ts": 1832,
	"./templates/team/espart/definition": 5333,
	"./templates/team/espart/definition.ts": 5333,
	"./templates/team/espart/helpers": 3311,
	"./templates/team/espart/helpers.ts": 3311,
	"./templates/team/espart/i18n": 2281,
	"./templates/team/espart/i18n/": 2281,
	"./templates/team/espart/i18n/en_UK": 4934,
	"./templates/team/espart/i18n/en_UK.json": 4934,
	"./templates/team/espart/i18n/index": 2281,
	"./templates/team/espart/i18n/index.tsx": 2281,
	"./templates/team/lanqq/assets/style.module.css": 4751,
	"./templates/team/lanqq/components/Achievements": 1339,
	"./templates/team/lanqq/components/Achievements.tsx": 1339,
	"./templates/team/lanqq/components/Activities": 1852,
	"./templates/team/lanqq/components/Activities.tsx": 1852,
	"./templates/team/lanqq/components/Gallery": 7713,
	"./templates/team/lanqq/components/Gallery.tsx": 7713,
	"./templates/team/lanqq/components/Home": 7334,
	"./templates/team/lanqq/components/Home.tsx": 7334,
	"./templates/team/lanqq/components/Landing": 554,
	"./templates/team/lanqq/components/Landing.tsx": 554,
	"./templates/team/lanqq/components/Members": 7706,
	"./templates/team/lanqq/components/Members.tsx": 7706,
	"./templates/team/lanqq/components/News": 630,
	"./templates/team/lanqq/components/News.tsx": 630,
	"./templates/team/lanqq/components/Schedule": 8232,
	"./templates/team/lanqq/components/Schedule.tsx": 8232,
	"./templates/team/lanqq/components/Store": 5948,
	"./templates/team/lanqq/components/Store.tsx": 5948,
	"./templates/team/lanqq/components/common/Btn": 9729,
	"./templates/team/lanqq/components/common/Btn.tsx": 9729,
	"./templates/team/lanqq/components/common/FilterChips": 3142,
	"./templates/team/lanqq/components/common/FilterChips.tsx": 3142,
	"./templates/team/lanqq/components/common/GalleryItem": 5098,
	"./templates/team/lanqq/components/common/GalleryItem.tsx": 5098,
	"./templates/team/lanqq/components/common/MatchCard": 1936,
	"./templates/team/lanqq/components/common/MatchCard.tsx": 1936,
	"./templates/team/lanqq/components/common/MatchRow": 4892,
	"./templates/team/lanqq/components/common/MatchRow.tsx": 4892,
	"./templates/team/lanqq/components/common/MemberCard": 789,
	"./templates/team/lanqq/components/common/MemberCard.tsx": 789,
	"./templates/team/lanqq/components/common/MemberModal": 3040,
	"./templates/team/lanqq/components/common/MemberModal.tsx": 3040,
	"./templates/team/lanqq/components/common/NewsCard": 2438,
	"./templates/team/lanqq/components/common/NewsCard.tsx": 2438,
	"./templates/team/lanqq/components/common/PageHead": 5046,
	"./templates/team/lanqq/components/common/PageHead.tsx": 5046,
	"./templates/team/lanqq/components/common/Pagination": 1765,
	"./templates/team/lanqq/components/common/Pagination.tsx": 1765,
	"./templates/team/lanqq/components/common/ProductCard": 298,
	"./templates/team/lanqq/components/common/ProductCard.tsx": 298,
	"./templates/team/lanqq/components/common/ScrollTrack": 8029,
	"./templates/team/lanqq/components/common/ScrollTrack.tsx": 8029,
	"./templates/team/lanqq/components/common/TournamentCard": 510,
	"./templates/team/lanqq/components/common/TournamentCard.tsx": 510,
	"./templates/team/lanqq/components/common/TrophyCard": 8981,
	"./templates/team/lanqq/components/common/TrophyCard.tsx": 8981,
	"./templates/team/lanqq/components/common/match": 1342,
	"./templates/team/lanqq/components/common/match.ts": 1342,
	"./templates/team/lanqq/components/home/EventSlider": 5224,
	"./templates/team/lanqq/components/home/EventSlider.tsx": 5224,
	"./templates/team/lanqq/components/home/FeatureCards": 9776,
	"./templates/team/lanqq/components/home/FeatureCards.tsx": 9776,
	"./templates/team/lanqq/components/home/GalleryRow": 7541,
	"./templates/team/lanqq/components/home/GalleryRow.tsx": 7541,
	"./templates/team/lanqq/components/home/HeroSlider": 5328,
	"./templates/team/lanqq/components/home/HeroSlider.tsx": 5328,
	"./templates/team/lanqq/components/home/Partners": 3794,
	"./templates/team/lanqq/components/home/Partners.tsx": 3794,
	"./templates/team/lanqq/components/home/ShopRow": 8815,
	"./templates/team/lanqq/components/home/ShopRow.tsx": 8815,
	"./templates/team/lanqq/components/home/SquadGrid": 7621,
	"./templates/team/lanqq/components/home/SquadGrid.tsx": 7621,
	"./templates/team/lanqq/components/home/UpcomingMatches": 2434,
	"./templates/team/lanqq/components/home/UpcomingMatches.tsx": 2434,
	"./templates/team/lanqq/components/layout/Footer": 6879,
	"./templates/team/lanqq/components/layout/Footer.tsx": 6879,
	"./templates/team/lanqq/components/layout/Navbar": 2732,
	"./templates/team/lanqq/components/layout/Navbar.tsx": 2732,
	"./templates/team/lanqq/data": 1830,
	"./templates/team/lanqq/data.ts": 1830,
	"./templates/team/lanqq/definition": 6419,
	"./templates/team/lanqq/definition.ts": 6419,
	"./templates/team/lanqq/helpers": 5169,
	"./templates/team/lanqq/helpers.ts": 5169,
	"./templates/team/lanqq/i18n": 9407,
	"./templates/team/lanqq/i18n/": 9407,
	"./templates/team/lanqq/i18n/en_UK": 2348,
	"./templates/team/lanqq/i18n/en_UK.json": 2348,
	"./templates/team/lanqq/i18n/index": 9407,
	"./templates/team/lanqq/i18n/index.tsx": 9407,
	"./templates/team/launchpad/assets/style.module.css": 3272,
	"./templates/team/launchpad/components/Activities": 9995,
	"./templates/team/launchpad/components/Activities.tsx": 9995,
	"./templates/team/launchpad/components/Gallery": 9068,
	"./templates/team/launchpad/components/Gallery.tsx": 9068,
	"./templates/team/launchpad/components/Home": 3237,
	"./templates/team/launchpad/components/Home.tsx": 3237,
	"./templates/team/launchpad/components/Landing": 3895,
	"./templates/team/launchpad/components/Landing.tsx": 3895,
	"./templates/team/launchpad/components/Members": 6915,
	"./templates/team/launchpad/components/Members.tsx": 6915,
	"./templates/team/launchpad/components/News": 6861,
	"./templates/team/launchpad/components/News.tsx": 6861,
	"./templates/team/launchpad/components/Schedule": 8583,
	"./templates/team/launchpad/components/Schedule.tsx": 8583,
	"./templates/team/launchpad/definition": 7092,
	"./templates/team/launchpad/definition.ts": 7092,
	"./templates/team/launchpad/i18n": 8470,
	"./templates/team/launchpad/i18n/": 8470,
	"./templates/team/launchpad/i18n/en_UK": 4883,
	"./templates/team/launchpad/i18n/en_UK.json": 4883,
	"./templates/team/launchpad/i18n/index": 8470,
	"./templates/team/launchpad/i18n/index.tsx": 8470,
	"./templates/tournament/launchpad/assets/style.module.css": 3430,
	"./templates/tournament/launchpad/components/About": 4807,
	"./templates/tournament/launchpad/components/About.tsx": 4807,
	"./templates/tournament/launchpad/components/Events": 2169,
	"./templates/tournament/launchpad/components/Events.tsx": 2169,
	"./templates/tournament/launchpad/components/Gallery": 9998,
	"./templates/tournament/launchpad/components/Gallery.tsx": 9998,
	"./templates/tournament/launchpad/components/Landing": 3781,
	"./templates/tournament/launchpad/components/Landing.tsx": 3781,
	"./templates/tournament/launchpad/components/Leaderboard": 7289,
	"./templates/tournament/launchpad/components/Leaderboard.tsx": 7289,
	"./templates/tournament/launchpad/components/Participants": 2640,
	"./templates/tournament/launchpad/components/Participants.tsx": 2640,
	"./templates/tournament/launchpad/components/Schedule": 8101,
	"./templates/tournament/launchpad/components/Schedule.tsx": 8101,
	"./templates/tournament/launchpad/components/Trophies": 2964,
	"./templates/tournament/launchpad/components/Trophies.tsx": 2964,
	"./templates/tournament/launchpad/definition": 8166,
	"./templates/tournament/launchpad/definition.ts": 8166,
	"./utils": 9640,
	"./utils/": 9640,
	"./utils/CacheManager": 6487,
	"./utils/CacheManager.ts": 6487,
	"./utils/Encryptor": 7564,
	"./utils/Encryptor.ts": 7564,
	"./utils/TemplateColors": 8492,
	"./utils/TemplateColors.ts": 8492,
	"./utils/index": 9640,
	"./utils/index.tsx": 9640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;